<template>
	<a
		:href="href"
		:download="download"
		@click="$emit( 'click' )"
		:class="classNames"
	>
		<slot name="innerAnchorSlot">
			{{ anchorText }}
		</slot>
	</a>
</template>

<script>
	export default {
		name  : "DownloadFileAnchor",
		props : {
			anchorText: {
				type    : String,
				default : ""
			},
			/* download is an attribute for telling browsers what type of file is being downloaded,
			** I.E. file name or extension
			** The download attribute is fine for most files, but
			** https://www.epa.gov/web-policies-and-procedures/web-standard-file-links-formats-and-pdf-guidelines
			** states that PDF's should download within a new tab and all files should state the file extension
			** I.E. <a href="https://nepis.epa.gov/Exe/ZyPDF.cgi/P1003UAI.PDF?Dockey=P1003UAI.PDF" data-once="external-links protected-links">Care For Your Air: A Guide to Indoor Air Quality (pdf)</a>
			**/
			download: {
				type     : String,
				required : true
			},
			href: {
				type     : String,
				required : true
			},
			classNames: {
				type    : String,
				default : ""
			}
		}
	};
</script>
